export default class PasswordChange {
  constructor() {
    if (this.vars()) {
      this.setupEvents();
    }
  }

  vars() {
    this.form = document.getElementById('userPasswordForm');

    if (!this.form) return;

    this.action = this.form.getAttribute('action');
    this.elements = this.form.elements;
    this.oldPassword = document.getElementById('new_password');

    this.errors = [];

    return true;
  }

  setupEvents() {
    this.form.addEventListener('submit', (evt) => this.handleSubmit(evt));
  }

  handleSubmit(evt) {
    evt.preventDefault();
    this.clearValidationErrors();

    const data = this.buildData();

    if (!this.errors.length) {
      this.send(data);
    } else {
      this.throwValidationError();
    }
  }

  buildData() {
    let data = {};

    for (let i = 0; i < this.elements.length; i++) {
      const el = this.elements[i];

      if (el.getAttribute('type') !== 'submit') {
        const key = el.getAttribute('name');
        const val = el.value;
        this.validate(key, val);
        data[key] = val;
      }
    }

    return data;
  }

  send(data) {
    axios.post(this.action, data)
    .then((response) => {
      if (response && response.data.code === 200) {
        document._kweber.toast({
          type: 'success',
          title: 'Hasło zmienione!'
        });
      } else if (response && response.data.code === 401) {
        const error = {
          name: 'password',
          msg: response.data.payload.error
        };
        this.errors.push(error);
        this.throwValidationError();
      } else if (response && response.data.code === 406) {
        const error = {
          name: 'new_password',
          msg: response.data.payload.error
        };
        const error2 = {
          name: 'confirm_password',
          msg: response.data.payload.error
        };
        this.errors.push(error);
        this.errors.push(error2);
        this.throwValidationError();
      } else {
        throw new Error(response);
      }
    })
    .catch((error) => {
      document._kweber.toast({
        type: 'error',
        title: 'Błąd zapisu, spróbuj ponownie'
      });
    });
  }

  validate(key, val) {
    if (key == 'password') {
      if (!val.length) {
        const error = {
          name: key,
          msg: 'Hasło jest wymagane'
        };
        this.errors.push(error);
      }
    }

    if (key == 'new_password') {
      if (!val.length) {
        const error = {
          name: key,
          msg: 'Nowe hasło jest wymagane'
        };
        this.errors.push(error);
      } else if (val.length < 6) {
        const error = {
          name: key,
          msg: 'Hasło musi mieć 6 znaków'
        };
        this.errors.push(error);
      }
    }

    if (key == 'confirm_password') {
      if (!val.length || val != this.oldPassword.value) {
        const error = {
          name: key,
          msg: 'Hasła muszą być identyczne'
        };
        this.errors.push(error);
      }
    }
  }

  throwValidationError() {
    this.errors.forEach((error) => {
      const field = this.elements.namedItem(error.name);
      const node = field.closest('div');
      field.classList.add('form-invalid-right');
      node.appendChild(this.getErrorNode(error.name, error.msg));
    });
  }

  clearValidationErrors() {
    this.errors = [];
    const errorNodes = this.form.getElementsByClassName('form-error');
    const errorFields = this.form.getElementsByClassName('form-invalid-right');
    Array.from(errorNodes).forEach((node) => {
      node.remove();
    });

    Array.from(errorFields).forEach((field) => {
      field.classList.remove('form-invalid-right');
    });
  }

  getErrorNode(key, msg) {
    const label = document.createElement("label");
    label.setAttribute('for', key);
    label.classList.add('form-error');
    label.classList.add('form-invalid-right');
    label.innerText = msg;
    return label;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Forms/PasswordChange.js